import { useCallback, useEffect, useState } from 'react';
import { buildAgentInboxItems } from '../services/agentInboxBuilder';

export default function useAgentInbox(moduleId) {
  const [items, setItems] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const refreshInbox = useCallback(async () => {
    if (!moduleId) {
      setItems([]);
      setIsLoading(false);
      return;
    }

    setIsLoading(true);
    try {
      const nextItems = await buildAgentInboxItems(moduleId);
      setItems(nextItems);
    } finally {
      setIsLoading(false);
    }
  }, [moduleId]);

  useEffect(() => {
    refreshInbox();
  }, [refreshInbox]);

  return {
    inboxItems: items,
    isInboxLoading: isLoading,
    refreshInbox,
  };
}
